export class Package {
    id?:number;
    packageName?:string;
    imageUrl?:string;
    routerLink?:string; //TODO add this variable to backend
    price?:number;
}
